import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  question: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  question,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="confirm-dialog">
      <DialogTitle id="confirm-dialog">{t("confirmDialog.title")}</DialogTitle>
      <DialogContent>
        <Typography>{question}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("confirmDialog.cancel")}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {t("confirmDialog.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
